"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = LocationSelectorInput;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = require("../../../common/styles/Input"),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _locationSelector = require("../styles/locationSelector");

function LocationSelectorInput(a) {
  var b = a.getInputProps,
      c = a.isManualEntry,
      d = a.placeholder,
      e = a.id,
      f = a.loading,
      g = a.disabled;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, _locationSelector.SELECTOR_INPUT_CONTAINER, f), "location-selector__input")
  }, _react["default"].createElement("input", b({
    placeholder: c ? "" : d,
    disabled: c || g,
    className: (0, _Input.INPUT)({
      disabled: !!c,
      valid: !0,
      styleType: "PRIMARY"
    }),
    id: e
  })), f ? _react["default"].createElement(_Icon["default"], {
    className: (0, _classnames["default"])("button-busy__icon", _locationSelector.LOADING_ICON),
    name: "shootstagrad",
    color: "bigFat"
  }) : null);
}